module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "venue-title-bar",
    style: (_vm.pageTitleBar)
  }, [_c('div', {
    staticClass: "venue-title"
  }, [_vm._v("\n      " + _vm._s(_vm.screenConfig ? _vm.screenConfig.screenName : '') + "\n    ")]), _vm._v(" "), (_vm.uploadedImageName) ? _c('div', {
    staticClass: "venue-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.uploadedImagePath,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "the-time"
  }, [_vm._v("\n      " + _vm._s(_vm.screenTime) + "\n    ")])]), _vm._v(" "), _c('Ticker'), _vm._v(" "), _c('div', {
    staticClass: "flex-race-container"
  }, _vm._l((_vm.venues), function(venue, index) {
    return _c('div', {
      key: index,
      staticClass: "flex-race-item",
      class: {
        noedge: venue.index % 3 === 0
      }
    }, [_c('div', {
      staticClass: "race-title-bar",
      style: (_vm.raceTitleBar)
    }, [_c('div', {
      staticClass: "race-venue-flag"
    }, [_c('img', {
      attrs: {
        "src": _vm.flagImage(venue.countryName),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "race-venue-name"
    }, [_c('div', {
      staticClass: "venue-name"
    }, [_vm._v("\n            " + _vm._s(_vm.venueDisplayName(venue.ve)) + "\n          ")]), _vm._v(" "), (venue.races.length) ? _c('div', {
      staticClass: "race-name"
    }, [_vm._v("\n            " + _vm._s(_vm._f("race")(venue.races[0].fn)) + " - " + _vm._s(_vm.raceTime(venue.races[0].raceDateTime)) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "race-titles"
    }, [_c('div', {
      staticClass: "place-title"
    }, [_vm._v("\n            PLACE\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "prev-title"
    }, [_vm._v("\n            PREV\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "price-title"
    }, [_vm._v("\n            PRICE\n          ")]), _vm._v(" "), (venue.races.length) ? _c('div', {
      staticClass: "race-places-paid"
    }, [_vm._v("\n            " + _vm._s(venue.races[0].placesPaid) + " PLACES PAID\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (venue.races.length) ? _c('div', {
      staticClass: "markets-container"
    }, [_vm._l((venue.races[0].markets), function(market) {
      return [(market.marketId) ? [(market.include) ? _c('Market', {
        key: market.id,
        attrs: {
          "places-paid": venue.races[0].placesPaid,
          "place-percentage": venue.races[0].placePercentage,
          "venue-id": venue.venueId,
          "race-id": venue.races[0].raceId,
          "market-id": market.marketId,
          "venue-index": index + 1
        }
      }) : _vm._e()] : _vm._e()]
    }), _vm._v(" "), _c('Market', {
      attrs: {
        "scroll-markets": venue.races[0].scrollMarkets,
        "places-paid": venue.races[0].placesPaid,
        "place-percentage": venue.races[0].placePercentage,
        "venue-id": venue.venueId,
        "race-id": venue.races[0].raceId,
        "venue-index": index + 1
      }
    })], 2) : _vm._e()])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50a9c673","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NextThree.vue
// module id = 234
// module chunks = 1